import { useQuery } from "@tanstack/react-query";
import { ScenarioRepository } from "../../domain/interfaces/ScenarioRepository";
import { ScenarioEntity } from "../../domain/scenario.entity";
import { scenariosQueryKeys } from "../../infrastructure/cache/ScenariosCacheStrategy";

interface UseScenariosOptions {
  enabled?: boolean;
}

export function useScenarios(
  propertyTicker: string,
  repository: ScenarioRepository,
  { enabled = true }: UseScenariosOptions = {}
) {
  return useQuery({
    queryKey: scenariosQueryKeys.list(propertyTicker),
    queryFn: (): Promise<ScenarioEntity[]> => repository.findByProperty(propertyTicker),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
